import { Routes, Route, Navigate } from 'react-router-dom'

import ShippingRequestList from 'Presentation/Views/ShippingRequest/List/View'
import ShippingRequestFormView from 'Presentation/Views/ShippingRequest/Form/View'
import ShippingFormView from 'Presentation/Views/Shipping/Form/View'
import ShippingRequestScanView from 'Presentation/Views/ShippingRequest/Scan/View'
import { ShippingListViewContextProvider } from 'Presentation/Views/ShippingRequest/List/Context'
import { ShippingFormModalContextProvider } from 'Presentation/Views/ShippingRequest/Form/Context'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const ShippingRoutes = () => (
  <ShippingFormModalContextProvider>
    <ShippingListViewContextProvider>
      <Routes>
        <Route
          element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.shipping_request} />}>
          {/* Route: Shipping List */}
          <Route index element={<ShippingRequestList />} />
          {/* Route: Shipping List */}
          <Route path=':shippingRequestId/shipping-order/create' element={<ShippingFormView />} />
          <Route path='create' element={<ShippingRequestFormView />} />

          <Route path=':id' element={<ShippingRequestFormView />} />

          <Route
            path=':shippingRequestId/shipping-order/:detailId'
            element={<ShippingFormView />}
          />

          <Route path=':id/shipping-order/:detailId/scan' element={<ShippingRequestScanView />} />

          <Route path='*' element={<Navigate to='/home' replace />} />
        </Route>
      </Routes>
    </ShippingListViewContextProvider>
  </ShippingFormModalContextProvider>
)

export default ShippingRoutes
